import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as CommonUtils from './common-functions';

export function castFormControlAsFormArray(control: AbstractControl): FormArray {
  return control as FormArray;
}

export function showValidationMessage(control: AbstractControl | null, submitted: boolean): boolean {
  if (CommonUtils.isNullOrEmpty(control)) {
    return false;
  }
  const ctrl = control as AbstractControl;
  return ctrl.invalid && (submitted || ctrl.dirty);
}

export function copyFormControl<T>(form: FormGroup, bean: T): T {
  for (var attr in bean) {
    if (form.controls[attr]) {
      bean[attr] = form.controls[attr].value;
    }
  }
  return bean;
}

export function showTableValidationMessage(value: any | null, submitted: boolean): boolean {
  if (CommonUtils.isNullOrEmpty(value)) {
    return false;
  }
  return value && submitted;
}

export function noFullWidthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    /* 檢查所有全型字元，u3000是在Mac上發現的全型空白 */
    if (value && /[\u3000\uFF00-\uFFFF]/.test(value)) {
      return { fullWidth: true };
    }
    return null;
  };
}

/**
 * 動態 maxLength validator
 * 根據 getter 函式回傳的值來決定最大長度
 * @param maxLengthGetter 一個函式，回傳當前的最大長度
 * @returns ValidatorFn
 * 
 * 使用範例：
 * this.formBuilder.group({
 *   facility: [''],
 *   flyNo1: ['', [dynamicMaxLengthValidator(() => this.getFlyNoMaxLength())]]
 * })
 */
export function dynamicMaxLengthValidator(maxLengthGetter: () => number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const maxLength = maxLengthGetter();
    
    if (value && value.length > maxLength) {
      return { 
        maxlength: { 
          requiredLength: maxLength, 
          actualLength: value.length 
        } 
      };
    }
    return null;
  };
}
